import { EntityDataUsuario } from "../Domain/EntityDataUsuario";
import { EntityUserAccess } from "../Domain/EntityUserAccess";
import { AdapterStorage } from "./AdapterStorage";

export interface EntityDataPermiss {
    rendicionesCajaChica?: EntityUserAccess;
    rendicionesRendiciones?: EntityUserAccess;
}

export class AdapterDataPermiss {
    private static getDataPermiss(): EntityDataPermiss {
        const { dataPermiss } = AdapterStorage.get('dataPermiss');
        if (!dataPermiss) return {};
        return dataPermiss;
    }

    private static getUser(): EntityDataUsuario {
        return AdapterStorage.get('user').user;
    }

    public static setDataPermiss(data: EntityDataPermiss): void {
        AdapterStorage.set('dataPermiss', JSON.stringify(data));
    }


    public static gerPermissByModule(module: keyof EntityDataPermiss) {
        const { DatosTrabajo: { OT } } = this.getUser();

        const dataPermiss = this.getDataPermiss()[module];
        const dataOT = (dataPermiss?.Access.Global || dataPermiss?.Access.Globals || [])?.flatMap(row => row.Child?.flatMap(child => (child.Child || []).flatMap(row => (row.Child || []).map(row => row.Code))) || []);
        const cleanDataOT = new Set([...dataOT.filter(row => !!row), OT]);

        return {
            OT: Array.from(cleanDataOT).sort(),
        }
    }
}